import React from 'react';
import cls from 'classnames';

import { TextSimpleProps } from './TextSimple.types';

const TextSimple: React.FC<TextSimpleProps> = (props) => {
	return <div className={cls('text-simple', props.className)}>{props.children}</div>;
};

TextSimple.displayName = 'TextSimple';

export default TextSimple;
